import type {
  LayoutVisibilityConfig,
  PublicDisplayConfig,
  PublicResultsLayout,
} from '../types/domain';
import type { CompetitionPublic } from '../types/results';

const LAYOUT_VALUES: readonly PublicResultsLayout[] = ['CLASSIC', 'PODIUM', 'SPLIT_VIEW'];

const parseLayout = (value: string | null | undefined): PublicResultsLayout | null => {
  if (!value) return null;
  const up = value.toUpperCase() as PublicResultsLayout;
  return LAYOUT_VALUES.includes(up) ? up : null;
};

const normalizeLayout = (value: unknown): PublicResultsLayout =>
  LAYOUT_VALUES.includes(value as PublicResultsLayout) ? (value as PublicResultsLayout) : 'CLASSIC';

/**
 * Slozi PublicDisplayConfig z backendovych sloupcu + respektuje URL override
 * `?layout=xxx` (divak si muze sam vybrat zobrazeni bez potreby admin zmeny).
 *
 * Defaults zajistuji, ze stare zaznamy bez techto poli (nemely by existovat
 * diky migraci 012, ale pro jistotu) maji rozumny fallback.
 */
export const buildDisplayConfig = (
  comp: CompetitionPublic,
  urlOverrideLayout?: string | null,
  visibility?: LayoutVisibilityConfig | null,
): PublicDisplayConfig => {
  const overrideLayout = parseLayout(urlOverrideLayout);
  const raw = overrideLayout ?? normalizeLayout(comp.publicResultsLayout);
  const hidden = visibility ? visibility.publicLayouts[raw] === false : false;
  const fallback = visibility?.publicDefault ?? 'CLASSIC';
  const effectiveLayout = hidden ? fallback : raw;
  return {
    layout: effectiveLayout,
    showStartNumber: comp.publicShowStartNumber ?? true,
    showPenaltySeconds: comp.publicShowPenaltySeconds ?? true,
    showPoints: comp.publicShowPoints ?? true,
    showAttemptDetails: comp.publicShowAttemptDetails ?? false,
    showLaneDetails: comp.publicShowLaneDetails ?? false,
    showNote: comp.publicShowNote ?? false,
    rotationSeconds: comp.publicRotationSeconds ?? 10,
    rotateOverall: comp.publicRotateOverall ?? true,
    autoRefreshSeconds: comp.publicAutoRefreshSeconds ?? 15,
    themeMode: comp.publicThemeMode ?? 'AUTO',
    showLogo: comp.publicShowLogo ?? true,
    showOrganizerLogo: comp.publicShowOrganizerLogo ?? false,
    organizerLogoUrl: comp.publicOrganizerLogoUrl ?? null,
  };
};
